<template>
  <div id="container">
    <div class="product-status">
      <div class="search-style">
        <el-form :model="queryParams">
          <el-row :gutter="10">
            <el-col :span="14">
              <el-col :span="6" style="padding-left:0px !important">
                <el-form-item>
                  <el-select v-model="queryParams.column">
                    <el-option label="供应商名称" value="suName"></el-option>
                    <el-option label="活动状态" value="acState"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item v-show="queryParams.column!=='acState'">
                  <el-input v-model="queryParams.value" placeholder="请输入关键词"></el-input>
                </el-form-item>
                <el-form-item v-show="queryParams.column==='acState'">
                  <el-select v-model="queryParams.value">
                    <el-option label="未开始" :value="1"></el-option>
                    <el-option label="进行中" :value="2"></el-option>
                    <el-option label="已结束" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-button type="primary" @click="onSearch">搜索</el-button>
                  <el-button type @click="onSearchReset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="10">
              <el-form-item style="float: right;">
                <el-button type="primary" plain @click="addActivity">添加活动</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="box-table box-style" :style="{height:tableHeight+'px'}">
        <el-table
          ref="multipleTable"
          :data="activityTable"
          :max-height="tableHeight"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          border
        >
          <el-table-column prop="id" label="活动编号">
            <template slot-scope="scope">
              <div>{{scope.row.id || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="acTitle" label="活动标题" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{scope.row.acTitle || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="suName" label="供应商" show-overflow-tooltip>
            <template slot-scope="scope">
              <div
                class="skip line-limit-length"
                @click="onEdit(scope.row)"
              >{{scope.row.suName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="acStar" label="开始时间" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.acStar|dateFilterL}}</template>
          </el-table-column>
          <el-table-column prop="acEnd" label="结束时间" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.acEnd|dateFilterL}}</template>
          </el-table-column>
          <el-table-column label="活动状态">
            <template slot-scope="scope">{{scope.row.acState|acStateFilters}}</template>
          </el-table-column>
          <el-table-column prop="acceptanceSate" label="收款状态">
            <template slot-scope="scope">{{scope.row.acceptanceSate|acceptanceSateFilters}}</template>
          </el-table-column>
          <el-table-column prop="createUser" label="添加人">
            <template slot-scope="scope">
              <div>{{scope.row.createUser || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="添加时间" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
          </el-table-column>
          <!-- <el-table-column prop="actingBrand" width="110px" label="最后修改时间">
             <template slot-scope="scope">
              <div>{{scope.row.actingBrand |dateFilterL}}</div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" fixed="right" width="180px">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12">
                  <el-button
                    @click="editActivity(scope.row)"
                    v-show="scope.row.acState===3 && scope.row.acceptanceSate ===3"
                    type="text"
                  >重新发起</el-button>
                  <el-button type="text" @click="onSee(scope.row)">查看</el-button>
                </el-col>
                <el-col :span="12">
                  <el-button
                    type="text"
                    v-show="scope.row.acState===2"
                    @click="endActivity(scope.row)"
                  >结束活动</el-button>
                </el-col>
                <el-col :span="12">
                  <el-button
                    v-show="scope.row.acState===1"
                    type="text"
                    @click="onDeleteActivity(scope.row)"
                  >删除活动</el-button>
                </el-col>
                <el-col :span="12">
                  <el-button
                    v-show="scope.row.acState===3 && scope.row.acceptanceSate ===null"
                    type="text"
                    @click="collection(scope.row)"
                  >申请收款</el-button>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!-------------- 删除活动和结束活动 -------------->
    <again-hint ref="againHintRefs" @goToUpdata="onDelOrEnd" :content="content" :title="title"></again-hint>
  </div>
</template>
<script>
import { supplierActivityList } from '@/api/supplier/supplierManage'
import pagination from '@/components/pagination'
import againHint from '@/components/AgainHint/index'
import { formatDate } from '@/util/tool'
export default {
  components: {
    pagination,
    'again-hint': againHint
  },
  data () {
    return {
      queryParams: {},
      activityTable: [],
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 30, // 分页页数
      title: '', // 删除活动标题,结束活动标题
      content: '', // 删除活动标题,结束活动标题
      loadingTable: false,
      tableHeight: window.innerHeight - 320
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onEdit (row) {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: row.suId }
      })
    },
    // 活动列表
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: [this.queryParams],
        queryPageName: ''
      }
      supplierActivityList(this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.activityTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 搜索
    onSearch () {
      if (!this.queryParams.column || !this.queryParams.value) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.getList()
      }
    },
    // 重置
    onSearchReset () {
      this.pageSize = 30
      this.currentPage = 1
      this.queryParams = {}
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 分页页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 分页码数
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    // 结束活动
    endActivity (row) {
      this.title = '结束活动'
      this.content = '确定结束该活动？'
      this.$refs.againHintRefs.onInitial(row)
    },
    // 删除活动
    onDeleteActivity (row) {
      this.title = '删除活动'
      this.content = '确定删除该活动？'
      this.$refs.againHintRefs.onInitial(row)
    },
    // 再次确认删除还是结束活动
    async onDelOrEnd (params) {
      if (this.title === '删除活动') {
        // 删除活动
        const isSuccess = await this.$deleteActivity(params)
        if (isSuccess) {
          this.onSearch()
        }
      } else {
        // 结束活动
        const isSuccess = await this.$endActivity(params)
        if (isSuccess) {
          this.onSearch()
        }
      }
    },
    // 收款申请
    collection (row) {
      this.$router.push({
        path: '/crm/supplier/initiatCollection',
        query: { id: row.suId, name: row.suName }
      })
    },
    // 添加活动
    addActivity () {
      this.$router.push('/crm/supplier/activityAdd')
    },
    // 编辑活动
    editActivity (row) {
      this.$router.push({
        path: '/crm/supplier/activityEdit',
        query: {
          id: row.id,
          acState: row.acState,
          acceptanceSate: row.acceptanceSate,
          name: row.suName
        }
      })
    },
    // 查看
    onSee (row) {
      this.$router.push({
        path: '/crm/supplier/activityEdit',
        query: {
          id: row.id,
          acState: row.acState,
          acceptanceSate: row.acceptanceSate,
          name: row.suName
        }
      })
    }
  },
  filters: {
    acStateFilters: function (type) {
      if (type === 1) {
        return '未开始'
      } else if (type === 2) {
        return '进行中'
      } else if (type === 3) {
        return '已结束'
      }
    },
    acceptanceSateFilters: function (type) {
      if (type === 1) {
        return '收款审核'
      } else if (type === 2) {
        return '收款成功'
      } else if (type === 3) {
        return '审核不通过'
      } else {
        return '--'
      }
    },
    dateFilter
  }
}
function dateFilter (time) {
  const date = new Date(time)
  // eslint-disable-next-line no-undef
  return formatDate(date, 'yyyy-MM-dd hh:mm')
}
</script>
<style lang="scss" scoped>
.supplier-list {
  .supplier-list-form {
    padding: 10px 30px;
  }
}
</style>
